
TPS.Forms = {
    validator: null,
    // sets validation object to object variable set on form page/web part
    validationMessages: window.validationMessages,
    validationMessage_password: "Please enter a valid password.",
    /*
        setup jquery validate plugin to validate a specific
        container on a page using parentSelector
    */
    addValidatorMethods: function () {

        jQuery.validator.addMethod('av_phone',
            function (phone_number, element) {
                var re = /^(1[-. ]?)?(\([2-9]\d{2}\)|[2-9]\d{2})[-. ]?[2-9]\d{2}[-. ]?\d{4}(([xX]|ext|EXT)?\d{1,5})?$/;
                phone_number = phone_number.replace(/\s+/g, '');
                return this.optional(element) ||
                    phone_number.length > 9 &&
                    phone_number.match(re);
            });

        jQuery.validator.addMethod('av_postal',
            function (postal_code, element) {
                var re = /(^[abceghjklmnprstvxyABCEGHJKLMNPRSTVXY]\d[abceghjklmnprstvwxyzABCEGHJKLMNPRSTVWXYZ]( )?\d[abceghjklmnprstvwxyzABCEGHJKLMNPRSTVWXYZ]\d$)|(^\d{5}(-\d{4})?$)/;
                postal_code = postal_code.replace(/\s+/g, '');
                return this.optional(element) ||
                    postal_code.match(re);
            });

        jQuery.validator.addMethod('av_vin',
            function (vin_number, element) {
                var re = /(^[0-9A-HJ-NPR-Za-hj-npr-z]{17}$)/;
                vin_number = vin_number.replace(/\s+/g, '');
                return this.optional(element) ||
                    vin_number.length == 17
                vin_number.match(re);
            });

        jQuery.validator.addMethod('av_alpha_text',
            function (value, element) {
                // Allows Unicode letters (including accents), spaces, apostrophes, and hyphens.
                const re = /^[a-zA-ZÀ-ÿ' -]+$/;
                return this.optional(element) || re.test(value);
            });

        jQuery.validator.addMethod('av_password_check',
            function (value, element) {
                var check = false;
                if (element.dataset["passwordCheck"]) {
                    check = element.dataset["passwordCheck"] == "valid";
                }
                return this.optional(element) || check;
            },
            function () {
                // use this property which is updated
                // by the BE request to validate the field
                return TPS.Forms.validationMessage_password;                
            }
        );
    },
    useValidatorMethods: {
        av_phone: function (selector, message) {
            jQuery('#' + selector).rules('add', {
                av_phone: true,
                messages: {
                    av_phone: message
                }
            });
        },
        av_postal: function (selector, message) {
            jQuery('#' + selector).rules('add', {
                av_postal: true,
                messages: {
                    av_postal: message
                }
            });
        },
        av_email: function (selector, message) {
            jQuery('#' + selector).rules('add', {
                email: true,
                messages: {
                    email: message
                }
            });
        },
        av_vin: function (selector, message) {
            jQuery('#' + selector).rules('add', {
                av_vin: true,
                messages: {
                    av_vin: message
                }
            })
        },
        av_alpha_text: function (selector, message) {
            jQuery('#' + selector).rules('add', {
                av_alpha_text: true,
                messages: {
                    av_alpha_text: message
                }
            });
        },
        av_password_check: function (selector, message) {
            jQuery('#' + selector).rules('add', {
                av_password_check: true
                // we dont set the message here
                // because it is set on the return
                // from the BE validation
            });
            // we'll set a default value if a message is passed here
            if (message) {
                TPS.Forms.validationMessage_password = message;
            }
        }

    },
    setupClientValidation: function (parentSelector) {

        if (parentSelector) {
            TPS.Forms.addValidatorMethods();

            TPS.Forms.validator = jQuery('#form').validate({

                errorClass: 'form-control-error',
                errorElement: 'span',
                
                groups: {
                    dealerChoice: "preferredDealer dealershipByRetailerName"
                },
                
                errorPlacement: function (error, element) {
                    if (element.attr("name") == "preferredDealer" || element.attr("name") == "dealershipByRetailerName") {
                        error.appendTo("#dealer-group-error");
                    } else if (element.attr("id") == "phoneNumberMobile_sms") {
                        error.insertAfter(element);
                    } else {
                        error.appendTo(element.parents('.form-control-wrapper'));
                    }
                },
            });

            if (TPS.Forms.validationMessages) {

                /*
                    pass required validation messages to library
                */
                if (TPS.Forms.validationMessages.required) {
                    jQuery.each(TPS.Forms.validationMessages.required, function (k, v) {

                        // use the css attribute contains selector
                        var input = jQuery('[id*="' + k + '"]').first();

                        // check if we have an input, or a wrapper of radios / checkboxes
                        if (input[0] && !input.is(':input')) {
                            input = input.find(':input');
                        }

                        input.rules('add', {
                            messages: {
                                required: v
                            }
                        });



                    });


                    if (TPS.Forms.validationMessages.required.general) {
                        jQuery.validator.messages.required = TPS.Forms.validationMessages.required.general;
                    }

                }

                /*
                    pass required validation messages to library with conditions
                */
                if (TPS.Forms.validationMessages.requiredConditional) {
                    jQuery.each(TPS.Forms.validationMessages.requiredConditional, function (k, v) {
                        jQuery('#' + k).rules('remove');
                        if (jQuery('#' + v.field).val() == v.value) {
                            jQuery('#' + k).rules('add', {
                                messages: {
                                    required: v.message
                                }
                            });
                        };
                    });
                }

                /*
                    pass required validation messages to library for comparison fields
                    like confirm email or password
                */
                if (TPS.Forms.validationMessages.matches) {
                    jQuery.each(TPS.Forms.validationMessages.matches, function (k, v) {
                        jQuery('#' + k).rules('add', {
                            equalTo: '#' + v.compare_field,
                            messages: {
                                equalTo: v.message
                            }
                        });
                    });
                }

                /*
                    add minlength validation on fields, like password
                */
                if (TPS.Forms.validationMessages.minLength) {
                    jQuery.each(TPS.Forms.validationMessages.minLength, function (k, v) {

                        jQuery('#' + k).rules('add', {
                            minlength: parseInt(v.minLength),
                            messages: {
                                minlength: v.message
                            }
                        });

                    });
                }

                /*
                   add maxlength validation on fields
               */
                if (TPS.Forms.validationMessages.maxLength) {
                    jQuery.each(TPS.Forms.validationMessages.maxLength, function (k, v) {

                        jQuery('#' + k).rules('add', {
                            maxlength: parseInt(v.maxLength),
                            messages: {
                                minlength: v.message
                            }
                        });

                    });
                }
                /*
                    add pattern match validation on fields, like email/phone number
                */
                if (TPS.Forms.validationMessages.pattern) {
                    jQuery.each(TPS.Forms.validationMessages.pattern, function (k, v) {

                        TPS.Forms.useValidatorMethods[v.pattern](k, v.message);

                    });
                }
            }

            jQuery(parentSelector).find('.required :input').each(function () {

                if (TPS.Forms.validationMessages.requiredConditional != undefined && TPS.Forms.validationMessages.requiredConditional[this.id] != undefined) {
                    var v = TPS.Forms.validationMessages.requiredConditional[this.id];

                    if (jQuery('#' + v.field).val() == v.value) {
                        jQuery(this).rules('add', { required: true });
                    };
                } else {

                    jQuery(this).rules('add', { required: true });

                }
            });

            jQuery(parentSelector).find('.submit-form').on('click', function (e) {
                e.preventDefault();
                TPS.Forms.validator.form();
            });

        } else {
            console.log("no parent selector was specified");
        }
    },
    resetClientValidation: function () {

        TPS.Forms.validator.resetForm();

    },
    clearFormFields: function (parentSelector) {

        jQuery(parentSelector).find(':input').each(function () {
            if (jQuery(this).is(':radio') || jQuery(this).is(':checkbox')) {
                jQuery(this).prop('checked', false);
            } else if (jQuery(this).attr('type') != 'hidden') {
                jQuery(this).val('');
            }
        });

    },
    getFormVals: function (selector) {

        var f = {};

        jQuery(selector).find(":input").each(function () {
            var o = jQuery(this);
            if (o.attr('type') === 'checkbox') {
                f[o.attr('id')] = o.is(':checked');
            } else if (o.attr('type') === 'radio' && o.is(':checked')) {
                f[o.parent().attr('id')] = o.attr('value');
            } else {
                f[o.attr('id')] = jQuery.isArray(o.val()) ? o.val().toString() : o.val();
            }
        });

        return f;

    },
    changeFieldState: function (selector, disable) {

        jQuery(selector).find(":input").each(function () {
            jQuery(this).prop("disabled", disable);
        })

    },
    scrollToMessages: function (messages, showKey, selector, magellan, singleMessage) {

        if (!singleMessage) {

            var messageText = "";

            jQuery(messages).each(function (k, v) {
                if (showKey) {
                    messageText += '<strong>' + v.Key + ':</strong>&nbsp;';
                }
                messageText += v.Value + '<br/>';
            });

        } else {
            messageText = messages;
        }

        jQuery(selector).find('.message').html(messageText);

        jQuery(selector).removeClass('hidden').fadeIn(100, function () {
            // 
            if (!jQuery('body').hasClass('is-reveal-open')) {
                jQuery(magellan).trigger('click');
            }
        });

    },
    resetMessageBlock: function (selector) {
        jQuery(selector).fadeOut(100, function () {
            jQuery(selector).find('.message').empty();
        }).addClass('hidden');
    },
    createFormField: function (type, id, value, options, label, validation) {

        var input;
        if (type === 'select') {
            input = jQuery('<select>');
            input.append(jQuery('<option>').val('').text(label));

            jQuery.each(options, function (k, v) {

                input.append(jQuery('<option>').val(v.val).text(v.text));

            });
        } else if (type === 'textarea') {
            input = jQuery('<textarea>');
        } else {
            input = jQuery('<input>').attr('type', type);
            if (label) {
                input.attr('placeholder', label);
            }
        }

        if (label) {
            input.attr('aria-label', label);
        }

        if (validation) {
            input.attr('title', validation);
        }

        input.attr('id', id);
        input.val(value);
        return input;

    },
    createFormRow: function (f, r, cl) {

        var row = jQuery('<div>').addClass('row column form-row form-control-wrapper');

        if (r) {
            row.addClass('required');
        }

        if (cl) {
            row.addClass(cl);
        }

        row.append(f);

        return row;

    },
    preventMultipleSubmit: {
        init: function () {
            var prm = Sys.WebForms.PageRequestManager.getInstance();
            prm.add_initializeRequest(function (s, e) {
                // Disable submit button & show loader
                if (s._postBackSettings.sourceElement.nodeName === 'INPUT') {
                    $('input[type=submit]').attr('disabled', 'disabled');
                    $('input[type=submit]').nextAll().remove();
                    $('<i class="spinner"></i>').insertAfter('input[type=submit]');
                }
            });
            prm.add_endRequest(function (s, e) {
                // Hide form & show success message
                if (s._postBackSettings.sourceElement.nodeName === 'INPUT') {
                    try {
                        $('.formPanel').hide();
                        $('.successMessage').show();
                    } catch (err) { }
                }
            });
        }
    },
    setDatePickerRegion(_region) {

        if (_region === 'fr-CA') {

            // setting French regional labels for jquery UI datepicker
            $.datepicker.regional['fr'] = {
                clearText: 'Effacer',
                clearStatus: '',
                closeText: 'compléter',
                closeStatus: 'Fermer sans modifier',
                prevText: '&lt;Préc',
                prevStatus: 'Voir le mois précédent',
                nextText: 'Suiv&gt;',
                nextStatus: 'Voir le mois suivant',
                currentText: 'aujourd\'hui',
                currentStatus: 'Voir le mois courant',
                monthNames: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
                monthNamesShort: ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Jun', 'Jul', 'Aoû', 'Sep', 'Oct', 'Nov', 'Déc'],
                monthStatus: 'Voir un autre mois',
                yearStatus: 'Voir un autre année',
                weekHeader: 'Sm',
                weekStatus: '',
                dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
                dayNamesShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
                dayNamesMin: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
                dayStatus: 'Utiliser DD comme premier jour de la semaine',
                dateStatus: 'Choisir le DD, MM d',
                //dateFormat: 'dd/mm/yy', 
                firstDay: 0,
                initStatus: 'Choisir la date',
                isRTL: false
            };
            $.datepicker.setDefaults($.datepicker.regional['fr']);

        }
    },
    BizformHelpers: {
        labels: {
            txtAreaCountdown: "{count} characters remaining",
        },
        init: function (_labels) {
            const countdownClass = 'bizform-text-maxlenght-';
            const txtAreaControls = document.querySelectorAll('textarea.form-control');
            const _self = TPS.Forms.BizformHelpers;
            let element;
            let maxLength;

            if (_labels) {
                _self.labels = _labels;
            }

            txtAreaControls && txtAreaControls.forEach((control) => {
                const elemClasses = [...control.classList];
                // check if the textarea element has the countdown class
                const elemClass = elemClasses.filter(value => value.includes(countdownClass))[0];
                if (elemClass) {
                    element = control;
                    maxLength = parseInt(elemClass.split(countdownClass)[1]);
                    _self.txtAreaCountdown(element, maxLength);
                }
            });
        },
        txtAreaCountdown: function (element, maxLength) {
            // set the DIV element to show characters remaining message
            const countdownMsgWrapper = document.createElement('div');
            const countdownMsg = document.createElement('span');
            const _self = TPS.Forms.BizformHelpers;
            countdownMsgWrapper.classList.add('bizform-text-countdown-wrapper');
            countdownMsg.classList.add('bizform-text-countdown-msg');
            countdownMsgWrapper.appendChild(countdownMsg);
            element.insertAdjacentElement('afterend', countdownMsgWrapper);

            element.setAttribute('maxLength', maxLength);
            element.addEventListener('input', function (event) {
                let currentLength = event.target.textLength;
                if (currentLength > maxLength) {
                    this.value = this.value.slice(0, maxLength);
                }

                let remainingChar = maxLength - currentLength;
                let countdownString = _self.labels.txtAreaCountdown.replace('{count}', remainingChar);
                countdownMsg.style.display = "inline-block";
                countdownMsg.innerHTML = countdownString;
            });
        }
    },
    passwordCheck(passwordSelector, cultureCode) {

        jQuery(document).on('blur', passwordSelector, function (e) {

            var input = e.currentTarget;
            var inputVal = input ? input.value : "";
            var inputName = input ? input.name : "";
            var inputId = input ? input.id : "";
            
            // if input value is not empty, undefined or null
            // then check the password in the BE
            if (inputVal && inputName && inputId) {
                // set the input to read only during the check
                input.dataset["passwordCheck"] = "unknown";
                CMSApp.AV.API.Membership.IsPasswordValid(
                    inputVal, // the password value
                    cultureCode, // the current culture
                    function (data) {
                        // remove readonly state
                        if (data.HasErrors) {
                            input.dataset["passwordCheck"] = "invalid";
                            // if there is an error message, use it:
                            if (data.ErrorMessages && data.ErrorMessages[0] && data.ErrorMessages[0].BlockSubmit && data.ErrorMessages[0].Key == 'password') {
                                TPS.Forms.validationMessage_password = data.ErrorMessages[0].Value;
                            }
                        } else {
                            // todo clear the plugin invalid state
                            // and hide the message
                            input.dataset["passwordCheck"] = "valid";
                        }
                        // force the validation
                        TPS.Forms.validator.element("#" + inputId);
                    }
                );
            }
        });    
    }
}
